const PreLoader = ({ show }) => {
  if (!show) return null;

  return (
    <div className="preloader-overlay">
      <div className="loader"></div>
      <p>Please wait...</p>
    </div>
  );
};

export default PreLoader;